import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "nonzero",
  d: "M16.25 8h15.5a3.25 3.25 0 0 1 3.245 3.066l.005.184v2.749l1.75.001c2.9 0 5.25 2.35 5.25 5.25v13.5A3.25 3.25 0 0 1 38.75 36L35 35.999v1.751A3.25 3.25 0 0 1 31.75 41h-15.5A3.25 3.25 0 0 1 13 37.75v-1.751L9.25 36A3.25 3.25 0 0 1 6 32.75v-13.5C6 16.35 8.35 14 11.25 14l1.75-.001V11.25a3.25 3.25 0 0 1 3.066-3.245zh15.5zm15.5 20.5h-15.5a.75.75 0 0 0-.75.75v8.5c0 .414.336.75.75.75h15.5a.75.75 0 0 0 .75-.75v-8.5a.75.75 0 0 0-.75-.75m5-12h-25.5a2.75 2.75 0 0 0-2.75 2.75v13.5c0 .414.336.75.75.75l3.75-.001V29.25A3.25 3.25 0 0 1 16.25 26h15.5A3.25 3.25 0 0 1 35 29.25v4.249l3.75.001a.75.75 0 0 0 .75-.75v-13.5a2.75 2.75 0 0 0-2.75-2.75m-5-6h-15.5a.75.75 0 0 0-.743.648l-.007.102v2.749h17V11.25a.75.75 0 0 0-.648-.743z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }